import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Typography } from '@material-ui/core';

import SignupApplicationsTab from './components/SignupApplicationsTab.comp';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
    },
}));

// Standalone page under PBDQ in the main menu: everything submitted through the
// portal's sign-up chatbot (/powered-by-dq/chatbot).
function SignupApplications_ORG() {
    const classes = useStyles();

    return (
        <Container component="main" maxWidth='false'>
            <div className={classes.paper}>
                <Typography variant="h5" style={{ fontWeight: 600, margin: 0 }}>
                    Sign-up Applications
                </Typography>
            </div>
            <div style={{ width: '100%' }}>
                <SignupApplicationsTab />
            </div>
        </Container>
    );
}

export default SignupApplications_ORG;
